'use client';
/* eslint-disable @typescript-eslint/no-unused-vars */
import axios from 'axios';
import { assignBrandLogo, populateSiteConfig, } from './siteConfig/siteConfigSlice.js';
import { getConsentThunk } from './consent/consentSlice.js';
import { getComponentTrackingNames } from '../../tracking/constants.js';
import { getOptimizelyAbTrackingString } from './experiments/optimizelyTrackingString.js';
import { initAppleClientId } from '../features/loginWithApple/loginWithAppleSlice.js';
import { API_URLS } from '../../configs/constants/urls.js';
export const initializeApp = ({ config, context, locales, params, }) => async (dispatch) => {
    try {
        dispatch(populateSiteConfig({
            loginregistration: config,
            locales: locales,
            platformType: context.platformSite,
            device: context.device,
            currentLocale: context.locale,
            configInitialized: true,
            encodedGTLibraryUrl: params && 'encodedGTLibraryUrl' in params
                ? params.encodedGTLibraryUrl
                : undefined,
        }));
        const appleClientId = params && 'appleClientId' in params
            ? params.appleClientId
            : window.__PRELOADED_STATE__?.modal.props.params.appleClientId;
        appleClientId && dispatch(initAppleClientId(appleClientId));
        dispatch(getConsentThunk());
    }
    catch (error) {
        console.error('Error:', error);
    }
};
export const sendGlobalTrackingThunk = (trackingCallback, additionalTrackingParams) => async (_, getState) => {
    const state = getState();
    const { loginSource } = state.core.sourceData;
    const { activeView, activeWrapper } = state.core.wrapperContext;
    if (!window || !window?.stst_gt) {
        console.error('Error: window.stst_gt is not available.');
    }
    const trackingPayload = {
        pageName: window?.utag_data?.pageName,
        loginSource,
        componentTitle: getComponentTrackingNames(activeWrapper, activeView),
    };
    const builtTrackingPayload = trackingCallback({
        ...trackingPayload,
        ...additionalTrackingParams,
    });
    const payloadWithOptimizely = {
        ...builtTrackingPayload,
        trackingData: {
            ...builtTrackingPayload.trackingData,
            abTestClientSide: getOptimizelyAbTrackingString(),
            abTestServerSide: '',
        },
    };
    // move to helper
    window.stst_gt &&
        typeof window.stst_gt?.methods?.sendCustomEvent === 'function' &&
        window.stst_gt.methods.sendCustomEvent(payloadWithOptimizely.method, payloadWithOptimizely.triggeringEventPlace, payloadWithOptimizely.trackingData);
};
export const getBrandLogoThunk = (logoBrandName) => async (dispatch) => {
    await axios
        .get(API_URLS.SHARED_ASSETS.LOGO(logoBrandName))
        .then((response) => {
        dispatch(assignBrandLogo(response.data));
    });
};
//# sourceMappingURL=thunks.js.map